/* eslint-disable import/no-anonymous-default-export */
export default {
  auth: {
    loading: false,
    data: null,
    error: null,
  },
};
